import { Component, OnInit } from '@angular/core';
import {UserPrivilegeService} from '../../services/common/user-privilege/user-privilege.service';
import {AttributesApiService} from '../../services/api/users/attributes/attributes-api.service';
import {AlarmsApiService} from '../../services/api/alarms/alarms-api.service';
import * as _ from 'lodash';

@Component({
  selector: 'alarms-advanced',
  templateUrl: './alarms-advanced.component.html',
  styleUrls: ['./alarms-advanced.component.scss']
})
export class AlarmsAdvancedComponent implements OnInit {

  propertiesSuggestions: Array<string> = [];
  userPropertiesOptions = [];
  testResult = '';

  alarmsTypes: null;

  fieldToMatchOptions = [
    {label: 'Source URI Name', key: 'SRC_URI_NAME'},
    {label: 'Source URI User', key: 'SRC_URI_USER'},
    {label: 'Source URI Host', key: 'SRC_URI_HOST'},
    {label: 'Dest  URI Name', key: 'DST_URI_NAME'},
    {label: 'Dest URI User', key: 'DST_URI_USER'},
    {label: 'Dest URI Host', key: 'DST_URI_HOST'},
    {label: 'Source IP From LYNC', key: 'SRC_IP_FROM_LYNC'}
  ];

  matchingMethodOptions = [
    {label: 'Full', key: 'FULL'},
    {label: 'Contains', key: 'CONTAINS'},
    {label: 'Network Mask', key: 'NETWORK_MASK'}
  ];

  isUnauthorized: boolean;

  constructor(private userPrivilege: UserPrivilegeService,
              private alarmsApiService: AlarmsApiService,
              private attributeService: AttributesApiService) { }

  ngOnInit(): void {
    this.isUnauthorized = !this.userPrivilege.isAuthorized();
    Promise.all([this.attributeService.getAttributes(), this.alarmsApiService.getAdditionalInfoAlarms().toPromise()]).then(data => {
      data[0].forEach(attribute => {
        this.userPropertiesOptions.push({label: attribute.name, key: attribute.id});
        this.propertiesSuggestions.push(`[${attribute.name}]`);
      });

      this.alarmsTypes = data[1].map(additionalInfoAlarm => {
        return {
          ...additionalInfoAlarm,
          isOpen: true,
          template: additionalInfoAlarm.template ? this.replacePropertiesIdsToLabels(additionalInfoAlarm.template) : '',
          testValue: ''
        };
      });
    });

  }

  submit(alarmType): any  {
    const template = this.replacePropertiesLabelsToIds(alarmType.template);

    this.alarmsApiService.editAdditionalInfoAlarms({...alarmType, template}, alarmType.id).subscribe();
  }

  private replacePropertiesLabelsToIds(template): any {
    this.userPropertiesOptions.map(property => {
      template = _.replace(template, new RegExp(`@\\[${property.label}\\]`, 'g' ), `@[${property.key}]`);
    });

    return template;
  }

  private replacePropertiesIdsToLabels(template): any  {
    this.userPropertiesOptions.map(property => {
      template = _.replace(template, new RegExp(`@\\[${property.key}\\]`, 'g'), `@[${property.label}]`);
    });

    return template.trim();
  }

  testTemplate(alarmType): void {
    const template = this.replacePropertiesLabelsToIds(alarmType.template);

    this.alarmsApiService.testAdditionalInfoAlarms({...alarmType, template}).subscribe(testResult => {
      this.testResult = testResult && testResult.result ? testResult.result.replace(/\n/g, '<br>') : null;
    });
  }

  onSubmit(alarmType): void {
    const template = this.replacePropertiesLabelsToIds(alarmType.template);

    this.alarmsApiService.editAdditionalInfoAlarms({...alarmType, template}, alarmType.id).subscribe();
  }
}
